import { FormField } from '@/components/MultiStepForm/FormField/FormField'
import { format } from 'date-fns'
import { useEffect, useRef, useState } from 'react'
import { DayPicker } from 'react-day-picker'
import 'react-day-picker/style.css'
import styles from './GeneralInfoStep.module.css'

interface DatePickerFieldProps {
  label: string
  value: Date | undefined
  onChange: (date: Date | undefined) => void
  disabled: boolean
  error?: string
  minDate: Date
  maxDate: Date
  placeholder?: string
}

export const DatePickerField = ({
  label,
  value,
  onChange,
  disabled,
  error,
  minDate,
  maxDate,
  placeholder = 'Select date',
}: DatePickerFieldProps) => {
  const [showPicker, setShowPicker] = useState(false)
  const pickerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target as Node)) {
        setShowPicker(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleSelect = (date: Date | undefined) => {
    onChange(date)
    setShowPicker(false)
  }

  return (
    <FormField label={label} error={error}>
      <div className={styles.DatePickerWrapper} ref={pickerRef}>
        <input
          type="text"
          className={styles.DateInput}
          placeholder={placeholder}
          value={value && !disabled ? format(value, 'dd/MM/yyyy') : ''}
          onClick={() => !disabled && setShowPicker(!showPicker)}
          readOnly
          disabled={disabled}
        />
        {showPicker && !disabled && (
          <div className={styles.DatePickerDropdown}>
            <DayPicker
              mode="single"
              selected={value}
              onSelect={handleSelect}
              disabled={{ before: minDate, after: maxDate }}
              className={styles.CustomDayPicker}
            />
          </div>
        )}
      </div>
    </FormField>
  )
}
